"use client";

import React, { createContext, useContext, useMemo } from "react";
import type { ChartPanelId } from "@/vybe-trader-client/chart/stores/chartPanelTypes";

const ChartPanelContext = createContext<ChartPanelId>(0);

export function ChartPanelProvider({
  panelId,
  children,
}: {
  panelId: ChartPanelId;
  children: React.ReactNode;
}) {
  const value = useMemo(() => panelId, [panelId]);
  return (
    <ChartPanelContext.Provider value={value}>
      {children}
    </ChartPanelContext.Provider>
  );
}

/** Active chart slot (0–3) when inside desktop multi-chart; defaults to 0. */
export function useChartPanelId(): ChartPanelId {
  return useContext(ChartPanelContext);
}
